export const container = "c1ot6blu";
export const title = "thaqaiu";
export const text = "ton4nds";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");